import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class BbqProductIdentifier extends Component {
  connectedCallback() {
    super.connectedCallback();
    try {
      this.identifiers = JSON.parse(this.querySelector('[data-identifier-map]')?.textContent || '{}');
    } catch {
      this.identifiers = {};
    }
    const configurator = this.closest('[data-fireplace-configurator], [data-meridian-studio]');
    this.target =
      this.closest('[id*="ProductInformation-"]') || configurator?.querySelector('[id*="ProductInformation-"]');
    const visibleTitle = configurator?.querySelector('.ms-config > h1');
    if (visibleTitle && visibleTitle.nextElementSibling !== this) visibleTitle.after(this);
    this.target?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.target?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    event.promise.then(({ detail }) => {
      if (!detail?.resource) return;
      if (detail.productId && detail.productId !== this.dataset.productId) return;
      const resource = detail.resource;
      const key = String(resource.id || resource.variantId || '').replace('gid://shopify/ProductVariant/', '');
      const item = this.identifiers[key] || { label: 'SKU', value: resource.sku || '' };
      this.querySelector('[data-identifier-label]').textContent = `${item.label}:`;
      this.querySelector('[data-identifier-value]').textContent = item.value || '';
      this.style.display = item.value ? 'block' : 'none';
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-identifier] update failed', error);
    });
  };
}

if (!customElements.get('bbq-product-identifier')) {
  customElements.define('bbq-product-identifier', BbqProductIdentifier);
}
